var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { margin: "20px" } },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "140px" } },
        [
          _c("el-form-item", { attrs: { label: "申请人" } }, [
            _vm._v(" " + _vm._s(_vm.detail.userName) + " "),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "手机号" } }, [
            _vm._v(" " + _vm._s(_vm.detail.mobile) + " "),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "会员卡号" } }, [
            _vm._v(" " + _vm._s(_vm.detail.cardNo) + " "),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "审核进度" } },
            [
              _c(
                "el-steps",
                {
                  attrs: {
                    space: 100,
                    direction: "vertical",
                    active: _vm.activeStep,
                  },
                },
                _vm._l(_vm.detail.reviewList, function (item) {
                  return _c(
                    "el-step",
                    { attrs: { title: "", description: "" } },
                    [
                      _c("template", { slot: "title" }, [
                        item.status == -1
                          ? _c("div", [_vm._v("提交申请")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.status == 0
                          ? _c("div", [_vm._v("审核中")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.status == 1
                          ? _c("div", [_vm._v("系统审核通过")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.status == 2
                          ? _c("div", [_vm._v("系统审核未通过")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.status == 3
                          ? _c("div", [_vm._v("审核通过")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.status == 4
                          ? _c("div", [_vm._v("审核不通过")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.status == 5
                          ? _c("div", [_vm._v("申诉中")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.status == 6
                          ? _c("div", [_vm._v("申诉不通过")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.status == 7
                          ? _c("div", [_vm._v("申诉通过")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.status == 8
                          ? _c("div", [_vm._v("已领取")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.status == 9
                          ? _c("div", [_vm._v("已降级")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.status == 10
                          ? _c("div", [_vm._v("复审不通过")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.status == 11
                          ? _c("div", [_vm._v("提交申诉")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.status == 12
                          ? _c("div", [_vm._v("复审通过")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.status == 13
                          ? _c("div", [_vm._v("审核终止")])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("template", { slot: "description" }, [
                        item.status == 11
                          ? _c("div", [
                              _c("div", { staticClass: "custom-description" }, [
                                _vm._v(_vm._s(item.appealDesc)),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "custom-description" }, [
                                _vm._v(_vm._s(item.appealName)),
                              ]),
                              _vm._v(" "),
                              item.appealUrl
                                ? _c(
                                    "div",
                                    { staticClass: "subImg" },
                                    _vm._l(
                                      item.appealUrl.split(","),
                                      function (imgUrl) {
                                        return _c("img", {
                                          attrs: { src: imgUrl, alt: "alt" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.previewImg(imgUrl)
                                            },
                                          },
                                        })
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(item.createTime))]),
                            ])
                          : _c("div", [
                              _c("div", { staticClass: "custom-description" }, [
                                _vm._v(_vm._s(item.remark)),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(item.createTime))]),
                            ]),
                      ]),
                    ],
                    2
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            width: "600px",
            top: "10vh",
            "custom-class": "img-preview-dialog",
            "show-close": true,
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c("div", { staticStyle: { "text-align": "center" } }, [
            _c("img", {
              staticStyle: { "max-width": "100%", "max-height": "70vh" },
              attrs: { src: _vm.previewList[_vm.previewIndex] },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "10px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", disabled: _vm.previewIndex === 0 },
                  on: { click: _vm.prevImg },
                },
                [_vm._v("上一张")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    disabled: _vm.previewIndex === _vm.previewList.length - 1,
                  },
                  on: { click: _vm.nextImg },
                },
                [_vm._v("下一张")]
              ),
              _vm._v(" "),
              _c("span", { staticStyle: { "margin-left": "10px" } }, [
                _vm._v(
                  _vm._s(_vm.previewIndex + 1) +
                    "/" +
                    _vm._s(_vm.previewList.length)
                ),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }